import { useContext } from "react";
import { GroupItemContext } from "../../contexts/groupItemContext";

const useGroupItemContext = () => {
  const value = useContext(GroupItemContext);
  return value;
};

export default useGroupItemContext;
